import React, {useEffect, useRef} from 'react';

/* do not import the unprocessed src file */
import PinchZoomLibrary from 'pinch-zoom-js/dist/pinch-zoom.umd.js';

import {hasTouchSupport, isMobile} from 'topmeteo/utils/mobile-detect';

import PreventPageZoom from './PreventPageZoom';

const PinchZoom = ({children, Element, ...props}) => {
    const nodeRef = useRef(null);

    useEffect(
        () => {
            if (hasTouchSupport && isMobile) {
                nodeRef.current.pinchZoom = new PinchZoomLibrary(nodeRef.current, {
                    verticalPadding: 100,
                    setOffsetsOnce: true,
                });
            }
        },
        [nodeRef],
    );

    return (
        <Element {...props} ref={nodeRef}>
            <PreventPageZoom>
                {children}
            </PreventPageZoom>
        </Element>
    );
};

PinchZoom.defaultProps = {
    Element: 'div',
};

export default PinchZoom;
